<template>
  <div>
    <div class="">
      <div class="news__class">
        {{ news_detail.title }}
      </div>
      <div class="news_other_detail__class mt-2">
        <span> {{ news_detail.source }} | {{ news_detail.time }} ago </span>
        <v-spacer></v-spacer>
        <v-btn @click="shareLink('newDetailPage')" text>
          <v-icon size="20" color="#535353">mdi-share-variant-outline</v-icon>
        </v-btn>
      </div>
      <div class="article_text__class">
        {{ news_detail.description }}
      </div>
    </div>
    <div class="text-center pt-4">
      <v-btn text class="btn__class" @click="goToNews">
        <span>Read Full Article</span>
        <v-icon color="#FFFFFF" small right>mdi-open-in-new</v-icon>
      </v-btn>
    </div>
    <!-- <div class="py-6" v-else>
      <v-fab-transition>
        <v-btn text class="btn__class" width="90%" bottom center @click="goToNews">
          <span>Read Full Article</span>
          <v-icon color="#FFFFFF" small right>mdi-open-in-new</v-icon>
        </v-btn>
      </v-fab-transition>
    </div> -->
  </div>
</template>
<script>
import helper from "@/helper/index";
export default {
  name: "NewsDetailCard",
  props: {
    news_detail: {
      type: Object,
    },
    security: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    shareLink(refValue) {
      let url = location.href;
      let text = `Hey check out the news related to ${this.security.symbol} stock on Covesto Social Trading Platform.`;
      let title = "News";
      helper.shareSsAndLink(refValue, url, text, title);
    },
    goToNews() {
      if (this.$vuetify.breakpoint.xsOnly) {
        window.open(this.news_detail.news_url, "_self");
      } else {
        window.open(this.news_detail.news_url);
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
.news__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 23px;
  /* identical to box height, or 105% */

  color: #454545;
}
.news_other_detail__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
  display: flex;
  /* identical to box height, or 164% */

  color: #5c5c5c;
}
.article_text__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 23px;
  width: 100%;
  /* or 177% */

  color: #848484;
  word-wrap: break-word;
}
.btn__class {
  background: #2d8cff;
  border-radius: 6px;
  text-transform: none;
}
.btn__class >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  color: #ffffff;
}
@media only screen and (max-width: 600px) {
  .news__class {
    font-weight: 900;
    font-size: 16px;
    line-height: 23px;
  }
  .news_other_detail__class {
    font-weight: 400;
    font-size: 12px;
    line-height: 23px;
    display: flex;
  }
  .article_text__class {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 23px;
    width: 100%;
    /* or 177% */

    color: #848484;
    word-wrap: break-word;
  }
}
</style>
